import { createSlice } from '@reduxjs/toolkit';

const initialState = { categories: [], events: [], subscriptions: [] };

export const alertsSlice = createSlice({
  name: 'alerts',
  initialState: initialState,
  reducers: {
    clearAlerts: (state) => {
      state = initialState;
    },

    setAlertsState: (state, action) => {
      const { categories, events, subscriptions } = action.payload;
      return { categories, events, subscriptions };
    },

    addAlertSubscription: (state, action) => {
      return { ...state, subscriptions: state.subscriptions.concat(action.payload) };
    },

    modifyAlertSubscription: (state, action) => {
      const modifiedSubscription = action.payload;
      const other = state.subscriptions.filter((s) => s.id !== modifiedSubscription.id);
      return { ...state, subscriptions: other.concat(modifiedSubscription) };
    },

    removeAlertSubscription: (state, action) => {
      const filteredSubscriptions = state.subscriptions.filter((s) => s.id !== action.payload);
      return { ...state, subscriptions: filteredSubscriptions };
    },
  },
});

export const { clearAlerts, setAlertsState, addAlertSubscription, modifyAlertSubscription, removeAlertSubscription } =
  alertsSlice.actions;

export default alertsSlice.reducer;
